import type { LineItem } from '@/Infrastructure/types/CartDto';
import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL, PRODUCT_URL } = environment;

const PRODUCTS_BY_SKU_URL = `${PRODUCT_URL}/listing/by-skus`;

const chunkArray = (arr: string[], size: number): string[][] => {
  const result: string[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

const fetchOutOfStockProducts = async (skus: string[]): Promise<LineItem[]> => {
  const skuChunks = chunkArray(skus, 20);
  const allResults: LineItem[] = [];

  for (const chunk of skuChunks) {
    const response = await fetch(
      `${PRODUCTS_BY_SKU_URL}?skusList=${chunk.join(',')}`
    );
    const data = await response.json();
    allResults.push(...data.results);
  }

  return allResults;
};

export async function getBuyNowCart(
  cartId: string
): Promise<{ data: HttpCartDto }> {
  const expandParam =
    'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';

  const url = `${CART_URL}/active-cart?expand=${expandParam}`;

  const res = await httpClient.get<HttpCartDto>(url, {
    headers: {
      'x-cart-id': cartId
    }
  });

  const skus = res.data.outOfStockItems.map((item) => item.sku);

  const outOfStockProducts = skus.length
    ? await fetchOutOfStockProducts(skus)
    : [];

  const cart = {
    ...res.data,
    outOfStockItems: [
      ...res.data.outOfStockItems.map((item) => {
        const product = outOfStockProducts.find((p) => p.key === item.sku);
        return {
          ...item,
          ...product
        };
      })
    ]
  };

  return {
    data: cart
  };
}
